exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement[data-v-57371f36] {\n  padding: 0px 20px 10px;\n  height: 500px;\n  overflow: auto;\n  font-size: 14px;\n  color: #333;\n  line-height: 24px;\n}\n.agreement[data-v-57371f36]::-webkit-scrollbar {\n  width: 0 !important;\n}\n", ""]);

// exports
